export const directVacationsUrl = 'directVacations.com';

export const httpsUrl = (): string => {
  const is_production = process.env.NODE_ENV == 'production';
  return is_production == true ? '' : `https://${process.env.NEXT_PUBLIC_BASE_URL}`;
};

export const httpsUrlTrailingSlash = (): string => {
  const is_production = process.env.NODE_ENV == 'production';
  return is_production == true ? '/' : `https://${process.env.NEXT_PUBLIC_BASE_URL}/`;
};


/* Legacy Lucee server api */
export const apiUrl = (): string => {
  return `${httpsUrl()}/RESTAUTH`;
};

/* For logging into legacy owner dashboard */
export const generateSwitchPropertiesUrl = (propertyId: number): string => {
  return `${httpsUrl()}/?event=ownerAdmin:ownerAdmin.switchProperties&id=${propertyId}`;
};

export const generateTapechartUrl = (): string => {
  return `${httpsUrl()}/ownerAdmin/tapechart/`;
};

export const generatePropertyListingPageUrl = (propertyId: number): string => {
  return `${httpsUrl()}/${propertyId}`;
};

export const alluraWhistlerUrl = `${httpsUrl()}/whistler/`;
export const alluraBigWhiteUrl = `${httpsUrl()}/bigwhite/`;
export const alluraSunPeaksUrl = `${httpsUrl()}/sunpeaks/`;


export const loginHostUrl = `${httpsUrl()}/login-host/`;
export const loginGuestUrl = `${httpsUrl()}/login-guest/`;
